<div class="col-6 col-md-4 col-xl-3">
	<div class="row mb-3 margin-bottom-0" [attr.data-test-id]="'invoiceServiceDateFormGroup'">
		<label class="col-md-4 col-form-label">Service Date</label>
		<div class="col-md-8">
			<p class="form-control-static">
				@if (displayServiceDateLink()) {
					<a revTooltip [tooltipContent]="serviceDateTooltipContent" [attr.data-test-id]="'invoiceNavigateServiceDateButton'"
					   (click)="navigateToEncounterOrAppointment()">{{ invoice.serviceDate | date: dateFormat }}</a>
				}
				@if (!displayServiceDateLink()) {
					<span>{{ invoice.serviceDate | date: dateFormat }}</span>
				}
				@if (canChangeEncounter()) {
					<a (click)="openEncounterOrAppointmentSelectModal()" class="margin-left-xs" revTooltip tooltipContent="Edit"
					   [attr.data-test-id]="'invoiceEditServiceDateButton'"><i class="fa fa-pencil"></i></a>
				}
				@if (canDisassociateEncounter()) {
					<a (click)="openDisassociateModal(true)" class="margin-left-xs" revTooltip tooltipContent="Remove"
					   [attr.data-test-id]="'invoiceRemoveServiceDateButton'">
						<i class="fa fa-close"></i>
					</a>
				}
				@if (canDisassociateAppointment()) {
					<a (click)="openDisassociateModal(false)" class="margin-left-xs" revTooltip tooltipContent="Remove">
						<i class="fa fa-close"></i>
					</a>
				}
			</p>
		</div>
	</div>
	@if (isInvoicePayerType(payerType.PATIENT)) {
		<div class="row mb-3 margin-bottom-0" [attr.data-test-id]="'financeChargePlanFormGroup'">
			<label class="col-md-4 col-form-label">Finance Charge Plan</label>
			<div class="col-md-8">
				<p class="form-control-static">
					@if (financeChargePlan) {
						<span>{{ financeChargePlan.name }}</span>
					}
					@if (!financeChargePlan) {
						<span>None</span>
					}
					@if (canChangeFinanceChargePlan()) {
						<a (click)="openFinanceChargePlanSelectModal()" class="margin-left-xs" revTooltip tooltipContent="Edit"
						   [attr.data-test-id]="'invoiceEditFinanceChargePlanButton'"><i class="fa fa-pencil"></i></a>
					}
				</p>
			</div>
		</div>
	}
	@if (isInvoicePayerType(payerType.INSURANCE)) {
		<div class="row mb-3 margin-bottom-0" [attr.data-test-id]="'feeScheduleNameFormGroup'">
			<label class="col-md-4 col-form-label">Fee Schedule</label>
			<div class="col-md-8">
				<p class="form-control-static">
					@if (invoice.feeScheduleName) {
						<span>{{ invoice.feeScheduleName }}</span>
					}
					@if (!invoice.feeScheduleName) {
						<span>None</span>
					}
				</p>
			</div>
		</div>
	}
	@if (isInvoicePayerType(payerType.INSURANCE)) {
		<div class="row mb-3 margin-bottom-0" [attr.data-test-id]="'feeScheduleDateFormGroup'">
			<label class="col-md-4 col-form-label">Fee Date</label>
			<div class="col-md-8">
				<p class="form-control-static">
					@if (invoice.feeScheduleDate) {
						<span>{{ invoice.feeScheduleDate | date: dateFormat }}</span>
					}
					@if (!invoice.feeScheduleDate) {
						<span>None</span>
					}
				</p>
			</div>
		</div>
	}
</div>
<div class="col-6 col-md-4 col-xl-3">
	@if (invoice.firstStatementPrintDate) {
		<div class="row mb-3 margin-bottom-0" [attr.data-test-id]="'firstStatementPrintDateFormGroup'">
			<label class="col-md-4 col-form-label">First Stmt Print Date</label>
			<div class="col-md-8">
				<p class="form-control-static">{{ invoice.firstStatementPrintDate | date: dateFormat }}</p>
			</div>
		</div>
	}
	@if (invoice.statementPrintDate) {
		<div class="row mb-3 margin-bottom-0" [attr.data-test-id]="'lastStatementPrintDateFormGroup'">
			<label class="col-md-4 col-form-label">Last Stmt Print Date</label>
			<div class="col-md-8">
				<p class="form-control-static">{{ invoice.statementPrintDate | date: dateFormat }}</p>
			</div>
		</div>
	}
</div>
@if (patientCredit) {
	<div class="col-12 col-md-8 col-xl-3 text-end" [attr.data-test-id]="'availableCreditSection'">
		@if (isInvoicePayerType(payerType.PATIENT)) {
			<div class="alert alert-success display-inline-block text-nowrap margin-bottom-0 padding-sm">
				{{ patientCredit | currency }} Available Credit
			</div>
		}
	</div>
}
